import { BackLink } from '@interfaces/backLink'
import { BreadcrumbItem } from '@interfaces/breadcrumbs'
import { Location } from '@interfaces/entities/location/location'
import type { RootState } from '@redux/store'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

interface SiteState {
  activeSection: string
  activeRecord: string
  activeLocation: Location | null
  asideOpened: boolean
  header: {
    backLink: BackLink | null
    info: string | null
    breadcrumbs: BreadcrumbItem[]
    inviteButtonVisible: boolean
    actionsButtonVisible: boolean
  }
}

const initialState: SiteState = {
  activeSection: 'Community',
  activeRecord: '',
  activeLocation: {
    name: 'PS 122',
  },
  asideOpened: false,
  header: {
    backLink: null,
    breadcrumbs: [],
    inviteButtonVisible: false,
    actionsButtonVisible: false,
    info: null,
  },
}

export const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setActiveSection: (state, action: PayloadAction<string>) => {
      state.activeSection = action.payload
    },
    setActiveRecord: (state, action: PayloadAction<string>) => {
      state.activeRecord = action.payload
    },
    setHeaderInfo: (state, action: PayloadAction<string>) => {
      state.header.info = action.payload
    },
    setActiveLocation: (state, action: PayloadAction<Location>) => {
      state.activeLocation = action.payload
    },
    setAsideOpened: (state, action: PayloadAction<boolean>) => {
      state.asideOpened = action.payload
    },
    setBackLink: (state, action: PayloadAction<BackLink>) => {
      state.header.backLink = action.payload
    },
    setBreadcrumbs: (state, action: PayloadAction<BreadcrumbItem[]>) => {
      state.header.breadcrumbs = action.payload
    },
    setInviteButton: (state, action: PayloadAction<boolean>) => {
      state.header.inviteButtonVisible = action.payload
    },
    setActionsButton: (state, action: PayloadAction<boolean>) => {
      state.header.actionsButtonVisible = action.payload
    },
    clearBacklink: (state: SiteState) => {
      state.header.backLink = null
    },
    clearBreadcrumbs: (state: SiteState) => {
      state.header.breadcrumbs = []
    },
    clearHeaderInfo: (state: SiteState) => {
      state.header.info = null
    },
    clearSiteInformation: (state: SiteState) => {
      state = initialState

      return state
    },
  },
})

export const {
  setActiveSection,
  setActiveLocation,
  setHeaderInfo,
  setAsideOpened,
  setBackLink,
  setBreadcrumbs,
  setInviteButton,
  setActionsButton,
  clearBreadcrumbs,
  clearBacklink,
  clearHeaderInfo,
  clearSiteInformation,
} = siteSlice.actions

export const selectActiveSection = (state: RootState) =>
  state.site.activeSection
export const selectActiveLocation = (state: RootState) =>
  state.site.activeLocation
export const selectBackLink = (state: RootState) => state.site.header.backLink
export const selectActiveRecord = (state: RootState) => state.site.activeRecord
export const selectAsideOpened = (state: RootState) => state.site.asideOpened
export const selectBreadcrumbs = (state: RootState) =>
  state.site.header.breadcrumbs
export const selectInviteButtonVisible = (state: RootState) =>
  state.site.header.inviteButtonVisible
export const selectHeaderInfo = (state: RootState) => state.site.header.info
export const selectActionsButtonVisible = (state: RootState) =>
  state.site.header.actionsButtonVisible
